export default __webpack_public_path__ + "static/media/Avatar account.cbb66a9a.svg";